import { render, staticRenderFns } from "./PbDashboardTotalTimeAndJobs.vue?vue&type=template&id=5390eadf&"
import script from "./PbDashboardTotalTimeAndJobs.vue?vue&type=script&lang=js&"
export * from "./PbDashboardTotalTimeAndJobs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports